/**
 * Access rules for the GL → Treasurers Checks program.
 *
 * `glConfig.restrictTreasurerChecksToGlAdmins` (Settings → GL) decides who can open it:
 *  - checked   → GL Admins only (`GLAdministration`)
 *  - unchecked → every user with GL access (`GlRead`), i.e. the historical behavior
 *
 * `TmcSupport` bypasses both checks (handled inside `isAuthorised`).
 */

import { isAuthorised } from '../../store/auth/token';
import { authRoles } from '../../router/roleGroups';

export const GL_ADMIN_ROLES = ['GLAdministration'];

export const isTreasurerChecksRestricted = (glConfig) => {
  const config = glConfig || {};
  return !!config.restrictTreasurerChecksToGlAdmins;
};

export const canAccessTreasurerChecks = (glConfig) => {
  if (isTreasurerChecksRestricted(glConfig)) {
    return isAuthorised(GL_ADMIN_ROLES);
  }
  return isAuthorised(authRoles.GlRead);
};

/**
 * Router / guard friendly variant: makes sure `glConfig` is in the store before deciding.
 */
export const canAccessTreasurerChecksFromStore = async (store) => {
  await store.dispatch('SystemConfig/loadConfig', { requiredScope: 'glConfig' });
  return canAccessTreasurerChecks(store.state.SystemConfig.glSettingItem);
};

export default {
  GL_ADMIN_ROLES,
  isTreasurerChecksRestricted,
  canAccessTreasurerChecks,
  canAccessTreasurerChecksFromStore,
};
